import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import Role from '../models/Role';

export function getRoles(params) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.ROLE_LIST,
        params: params,
        parser: rolesDataParser,
    }).get();
}

export function getAllRoles() {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.ROLE_GET_ALL,
        parser: rolesDataParser,
    }).get();
}

export function getRoleDetail(id) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.ROLE_DETAIL,
        endpointParams: { id },
        parser: data => new Role(data.data),
    }).get();
}

export function createRole(role) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.ROLE_CREATE,
    }).post(role.export());
}

export function updateRole(role) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.ROLE_UPDATE,
        endpointParams: { id: role.id },
    }).put(role.export());
}

export function deleteRole(id) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.ROLE_DELETE,
        endpointParams: { id },
    }).delete();
}

function rolesDataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new Role(item))
    }
}